import { ScheduleSection } from '@/components/sections/ScheduleSection';

export const Itinerary: React.FC = () => {
    return (
        <div className="py-8">
            <ScheduleSection />
        </div>
    );
};
